import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

type PageMetaProps = {
  title: string
  description: string
}

export function PageMeta({ title, description }: PageMetaProps) {
  const { pathname } = useLocation()

  useEffect(() => {
    const pageTitle = `${title} — Informat Limited`
    const pathWithoutTrailingSlash = pathname === '/' ? '/' : pathname.replace(/\/+$/, '')
    const canonicalPath = pathWithoutTrailingSlash === '/privacy' ? '/privacy/' : pathWithoutTrailingSlash
    const canonicalUrl = new URL(canonicalPath, 'https://informat.ie').toString()

    const setMeta = (selector: string, attribute: 'name' | 'property', key: string, content: string) => {
      let element = document.querySelector<HTMLMetaElement>(selector)
      if (!element) {
        element = document.createElement('meta')
        element.setAttribute(attribute, key)
        document.head.append(element)
      }
      element.setAttribute('content', content)
    }

    let canonical = document.querySelector<HTMLLinkElement>('link[rel="canonical"]')
    if (!canonical) {
      canonical = document.createElement('link')
      canonical.setAttribute('rel', 'canonical')
      document.head.append(canonical)
    }

    document.title = pageTitle
    canonical.setAttribute('href', canonicalUrl)

    setMeta('meta[name="description"]', 'name', 'description', description)
    setMeta('meta[property="og:title"]', 'property', 'og:title', pageTitle)
    setMeta('meta[property="og:description"]', 'property', 'og:description', description)
    setMeta('meta[property="og:url"]', 'property', 'og:url', canonicalUrl)
    setMeta('meta[name="twitter:title"]', 'name', 'twitter:title', pageTitle)
    setMeta('meta[name="twitter:description"]', 'name', 'twitter:description', description)
  }, [description, pathname, title])

  return null
}
